import axios from "axios";
import axiosInstance from "./axiosInterceptors";


export const apiRoute = {
    loginUrl: "/super-admin-login",
    modules: "/quick-access",
    daycare: "/daycare",
    daycareStatus: "/daycare-status",
    subscription: '/subscription',
    subscriptionStatus: '/subscription-status',
    allsubscription: '/all-subscription',
    daycareById: '/daycare-details',
    daycareEnquiry: '/daycare-enquiry',
    updatenquiry: '/update-enquiry',
    relationType: '/relation-type',
    category: '/category',
    pricacyPolicy: '/privacy-policy',
    termCondition: '/term-condition',
    aboutUs: '/about-us',
    aboutDetails: '/details-about-us',
    termsDetails: '/details-term-condition',
    privacyDetails: '/details-privacy-policy',

    countValues: '/dashboard-analytics',
    revenueOverview: '/dashboard-revenue-overview-analytics',
    recentDaycare: '/dashboard-recently-added-daycare',
    mostUsedSubscription: '/dashboard-most-used-subscription',
    recentDaycareTransaction: '/dashboard-recent-transactions',
    topPerformanceDaycare: '/dashboard-top-performing-daycare',
    actionCenter: '/dashboard-action-center',

    getPaymentHistory: '/daycare-payment-history',
    resendPayment: '/resend-payment-link',
    notificationUrl: "/notifications",
    notificationReadUrl: "/notifications-mark-read",
    timezoneUrl: "/timezone",

}

//  authentication
export const adminLogin = (data) => axiosInstance.post(apiRoute.loginUrl, data);

//profile info
// export const fetchProfileDetails = () => axiosInstance.get(`${authUrl}${apiRoute.getProfileDetailsUrl}`);


// modules
export const fetchModules = ({ current, limit, searchParams }) => axiosInstance.get(apiRoute.modules, {
    params: { itemsPerPage: limit, currentPage: current, searchData: searchParams }
});
export const removeModules = (id) => axiosInstance.delete(apiRoute.modules, {
    data: { quickAccessId: id }
});
export const createModules = (data) => axiosInstance.post(apiRoute.modules, data);
export const updateModules = (data) => axiosInstance.put(apiRoute.modules, data);


// day care
export const fetchDaycare = ({ current, limit, searchParams, startDate, expireDate }) => axiosInstance.get(apiRoute.daycare, {
    params: { itemsPerPage: limit, currentPage: current, searchData: searchParams, startDateFrom: startDate, expiryDateFrom: expireDate }
});

export const fetchDaycareTimezone = () => axiosInstance.get(apiRoute.timezoneUrl);
export const fetchDaycareById = (daycareId) => axiosInstance.get(apiRoute.daycareById, {
    params: { daycareId: daycareId }
});

export const removeDaycare = (id) => axiosInstance.delete(apiRoute.daycare, {
    data: { quickAccessId: id }
});

export const createDaycare = (data) => axiosInstance.post(apiRoute.daycare, data);
export const updateDaycare = (data) => axiosInstance.put(apiRoute.daycare, data);
export const updateDaycareStatus = (data) => axiosInstance.post(apiRoute.daycareStatus, data);



// subscription
export const fetchSubscription = ({ current, limit, searchParams }) => axiosInstance.get(apiRoute.subscription, {
    params: { itemsPerPage: limit, currentPage: current, searchData: searchParams }
});
export const removeSubscription = (id) => axiosInstance.delete(apiRoute.subscription, {
    data: { subscriptionId: id }
});
export const createSubscription = (data) => axiosInstance.post(apiRoute.subscription, data);
export const fetchAllSubscription = () => axiosInstance.get(apiRoute.allsubscription);
export const updateSubscription = (data) => axiosInstance.put(apiRoute.subscription, data);
export const updateSubscriptionStatus = (data) => axiosInstance.post(apiRoute.subscriptionStatus, data);


// enquire
export const fetchDaycareEnquirey = ({ current, limit, searchParams, enquiryType, status }) => axiosInstance.get(apiRoute.daycareEnquiry, {
    params: { itemsPerPage: limit, currentPage: current, searchData: searchParams, enquiryType, enquiryStatus: status }
});

export const updateDaycareEnquirey = (data) => axiosInstance.put(apiRoute.daycareEnquiry, data);
export const updatePendingDaycareEnquirey = (data) => axiosInstance.put(apiRoute.updatenquiry, data);


// relation type
export const fetchRelationType = ({ current, limit, searchParams }) => axiosInstance.get(apiRoute.relationType, {
    params: { itemsPerPage: limit, currentPage: current, searchData: searchParams }
});
export const removeRelationType = (id) => axiosInstance.delete(apiRoute.relationType, {
    data: { relationCodeId: id }
});
export const createRelationType = (data) => axiosInstance.post(apiRoute.relationType, data);
export const updateRelationType = (data) => axiosInstance.put(apiRoute.relationType, data);


// category 
export const fetchCategory = ({ searchParams, types }) => axiosInstance.get(apiRoute.category, {
    params: { searchData: searchParams, categoryType: types }
});
export const removeCategory = (id) => axiosInstance.delete(apiRoute.category, {
    data: { categoryId: id }
});
export const createCategory = (data) => axiosInstance.post(apiRoute.category, data);
export const updateCategory = (data) => axiosInstance.put(apiRoute.category, data);


// cms privacy 

export const fetchPrivacy = (cmsFor) => axiosInstance.get(apiRoute.pricacyPolicy, { params: { for: cmsFor } });
export const fetchPrivacyById = (id) => axiosInstance.get(apiRoute.privacyDetails, { params: { privacyPolicyId: id } });
export const createPrivacy = (data) => axiosInstance.post(apiRoute.pricacyPolicy, data);
export const updatePrivacy = (data) => axiosInstance.put(apiRoute.pricacyPolicy, data);

//Terms & condition

export const fetchTerms = (cmsFor) => axiosInstance.get(apiRoute.termCondition, { params: { for: cmsFor } });
export const fetchTermById = (id) => axiosInstance.get(apiRoute.termsDetails, { params: { termConditionId: id } });
export const createTerms = (data) => axiosInstance.post(apiRoute.termCondition, data);
export const updateTerms = (data) => axiosInstance.put(apiRoute.termCondition, data);

//aboutus

export const fetchAboutus = (cmsFor) => axiosInstance.get(apiRoute.aboutUs, { params: { for: cmsFor } });
export const fetchAboutusById = (id) => axiosInstance.get(apiRoute.aboutDetails, { params: { aboutUsId: id } });
export const createAboutus = (data) => axiosInstance.post(apiRoute.aboutUs, data);
export const updateAboutus = (data) => axiosInstance.put(apiRoute.aboutUs, data);

//dashboard
export const fetchCountValue = (params) => axiosInstance.get(apiRoute.countValues, { params });
export const fetchDaycareRevenue = (params) => axiosInstance.get(apiRoute.revenueOverview, { params });
export const fetchRecentDaycare = (params) => axiosInstance.get(apiRoute.recentDaycare, { params });
export const fetchMostUsedSubscription = (params) => axiosInstance.get(apiRoute.mostUsedSubscription, { params });
export const fetchRecentDaycareTransaction = (params) => axiosInstance.get(apiRoute.recentDaycareTransaction, { params });
export const fetchPerformanceDaycare = (params) => axiosInstance.get(apiRoute.topPerformanceDaycare, { params });
export const fetchActionCenter = (params) => axiosInstance.get(apiRoute.actionCenter, { params });

// Payment
export const fetchPaymentHistory = ({ current, limit, searchParams }) => axiosInstance.get(apiRoute.getPaymentHistory, {
    params: { itemsPerPage: limit, currentPage: current, searchData: searchParams }
});

export const resendPaymentLink = (body) => axiosInstance.post(apiRoute.resendPayment, body);

export const fetchNotifications = () => axiosInstance.get(apiRoute.notificationUrl)
export const readNotifications = (data) => axiosInstance.put(apiRoute.notificationReadUrl, data)